import axios from 'axios';
import DomManipulator from '../../classes/DomManipulator';
import Utility from '../../classes/Utility';

const successMessage = {
  title: `Thank you for signing up to ${window.websiteProperty}.com's free newsletter!`,
  message: "In order to finish the subscription process, we need to confirm your email address. We have sent a confirmation email to your email address."
}
const errorMessage = 'Sorry, you are not subscribed successfully. Please try again.';

const initEmailSubscribeInput = () => {
  const emailSubscribeDOM = document.querySelector('.email-subscribe');
  if (Utility.getCookie('newsletter_hide') == 'true' && emailSubscribeDOM) {
    emailSubscribeDOM.classList.add('t-hidden');
  }
}

const registerListener = () => {
  const emailForm = document.querySelector('.email-subscribe-form');
  if (!emailForm) return;
  emailForm.addEventListener('submit', (e) => {
    const emailAddress = emailForm.querySelector('input').value;
    e.stopPropagation();
    if (emailAddress) {
      subscribe(emailAddress);
    } else {
      window.location = mailchimpAction;
    }
  })
}

const subscribe = (emailAddress) => {
  // Get current URL without domain (cross-browser compatible)
  const fullUrl = window.location.href;
  const origin = window.location.origin || 
                (window.location.protocol + "//" + window.location.hostname + 
                (window.location.port ? ':' + window.location.port : ''));
  const currentUrl = fullUrl.substring(origin.length);
  
  axios.post('/api/newsletter/', {
    email: emailAddress,
    signup_location: currentUrl
  }).then(function () {
    document.cookie = 'stop_exit_interstitial_without-ads=true; expires=Thu, 2 Aug 3020 20:00:00 UTC; path=/;SameSite=None;secure';
    document.cookie = 'newsletter_email=' + emailAddress + '; expires=Thu, 2 Aug 2020 20:00:00 UTC; path=/;SameSite=None;secure';
    showSuccessAlert();
  }).catch(()=> {
     showErrorAlert();
  });
}

const showSuccessAlert = () => {
  window.EventManager.emit('flash-message', {
    status: 'SUCCESS',
    title: successMessage.title,
    message: successMessage.message
  });
}

const showErrorAlert = () => {
  window.EventManager.emit('flash-message', {
    status: 'ERROR',
    title: errorMessage,
  });
}

DomManipulator.addToQueue({
  requires: '',
  methods: [initEmailSubscribeInput, registerListener],
  unblocks: ''
});
